import axios from "axios";
import {
  // getToken, 
  refreshPage
} from "../Utils/Common";
import toast from "react-hot-toast";

// Set up a global response interceptor
// axios.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   async (error) => {
//     if (error.response && error.response.status === 401) {
//       const requestUrl = error.config?.url;

//       const ignored401Endpoints = ["/authenticate/index", "login/index", "logout/index"];
//       const shouldLogout = !ignored401Endpoints.some(path => requestUrl.includes(path));
  
//       if (shouldLogout) {
//         localStorage.clear();
//         toast.error("Unauthorized. Logging you out...", { autoClose: 5000 });
//         setTimeout(() => {
//           window.location.href = "/";
//           refreshPage();
//         }, 1000);
//       }
//     }

//     // Propagate the error to the calling code
//     return Promise.reject(error);
//   }
// );

var config = {
    "api-key": process.env.REACT_APP_API_KEY,
};

var putconfig = {
    "api-key": process.env.REACT_APP_API_KEY,
    "Content-Type": "application/x-www-form-urlencoded",
};

var fileconfig = {
    "api-key": process.env.REACT_APP_API_KEY,
};

var configFormData = {
  "api-key": "daccfc89-ff47-4ce1-99bf-5ad2d8f57282",
  "Content-Type": "multipart/form-data",
}

// API Axios Get Call
export const getAPICall = (url, data) => {
    return axios.get(url, { headers: config }, data);
};

export const getWithParamsAPICall = (url, data) => {
    return axios.get(url, { headers: config, params: data });
};
// API Axios Post Call.
export const postAPICall = (url, data) => {
    return axios.post(url, data, { headers: config });
};

// API Axios Post Call.
export const postAPICall2 = (url, data, config) => {
    return axios.post(url, data, { headers: fileconfig });
};

// API Axios Post Call.
export const postAPICallPrint = (url, data, index) => {
  return axios.post(url, data, { 
      headers: { 
          "api-key": process.env.REACT_APP_API_KEY,
          "Authorization": `Bearer ${String(sessionStorage.getItem("authToken"))}${index}`
      } 
  });
};


export const postFormData = (url, data) => {
  return axios.post(url, data, { headers: configFormData });
};

// API Axios Put Call.
export const putAPICall = (url, data) => {
    return axios.put(url, data, { headers: putconfig });
};
// API Axios Delete Call.
export const deleteAPICall = (url) => {
    return axios.delete(url, { headers: config });
};
